import * as React from "react";
import { Trans } from "react-i18next";
import { ExperienceTransactionReferralDetailsFragmentFragment } from "../../../hooks/useXPTransactions/graphql/XPTransactionsFragment.generated";

export const ExperienceTransactionReferralDetails = ({
  details,
  earnedXP,
  totalXP,
}: {
  details: ExperienceTransactionReferralDetailsFragmentFragment;
  earnedXP: number;
  totalXP: number;
}) => {
  return (
    <Trans
      i18nKey="xp_transaction.ExperienceTransactionReferralDetails"
      components={{
        xp: <span className="font-bold" />,
        total: <span className="font-bold" />,
      }}
      values={{ xp: earnedXP, total: totalXP }}
    />
  );
};
